<template>
  <div class="flex gap-2 mb-8">
    <ContactStage :stage="1" :currentStage="stage" />
    <ContactStage
      @click="$emit('gotoBranchSelect')"
      :class="{
        'cursor-pointer': stage > 2,
      }"
      :stage="2"
      :currentStage="stage"
    />
    <ContactStage :stage="3" :currentStage="stage" />
  </div>
</template>

<script>
import ContactStage from 'Components/ContactStage';
import HorizontalSeparator from 'Components/HorizontalSeparator';

export default {
  name: 'ContactStageIndicator',
  components: { HorizontalSeparator, ContactStage },
  props: {
    stage: {
      type: Number,
      default: 1,
    },
  },
  emits: ['gotoBranchSelect']
};
</script>
